var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "prices-list-card d-flex flex-column",
      class: { "ga-4": _setup.isMobile },
    },
    [
      _c(
        "div",
        {
          staticClass: "prices-list-card__body",
          class: _vm.borderless
            ? undefined
            : ["rounded-24", "border-sm", _setup.isMobile ? "pa-2" : "pa-4"],
          attrs: { "data-qa": _vm.listQa },
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.showAllHref && !_setup.isMobile
            ? _c(
                "div",
                { staticClass: "d-flex justify-center mt-2" },
                [
                  _c(_setup.PricesShowAllLink, {
                    attrs: { href: _vm.showAllHref, "data-qa": _vm.moreQa },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showAllHref && _setup.isMobile
        ? _c(_setup.PricesShowAllLink, {
            attrs: { href: _vm.showAllHref, "data-qa": _vm.moreQa },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }